
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aboutus",
      function () {
        return require("private-next-pages/aboutus.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aboutus"])
      });
    }
  